import React from 'react';
import { getImageURL } from '../../../../utils/GeneralUtil';
import { analyticsClick } from '../../../../utils/analytics';
import { fallbackImage } from '../../../../images';
import { rhAnalytics } from '../../../../constants/RewardsHub';
export var PaintInfoTooltip = function () {
    var tooltipTitle = 'Qualifying purchases for Paint Spend include all paint-supply purchases. You must identify as a Pro Xtra Member at checkout.';
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "info-tooltip" },
            React.createElement("span", { role: "button", tabIndex: 0, onClick: function () {
                    analyticsClick(rhAnalytics.paintInfoTooltip);
                } },
                React.createElement("img", { src: getImageURL('ProTiers/icon-info.svg'), alt: "paint-tooltip-icon", width: "16px", height: "16px", className: "info-tooltip-icon", onError: fallbackImage })),
            React.createElement("div", { className: "bottom tooltip-text" },
                React.createElement("p", null, tooltipTitle),
                React.createElement("i", null)))));
};
